import { defineStore } from 'pinia'

import type { ProfileStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useProfileStore = defineStore('profile', {
  state: (): ProfileStore => ({
    user: null,
    loading: false,
    options: null,
    privileges: null,
  }),
  actions,
  getters,
})
